import { Form } from 'react-bootstrap';
import { useGetDomainsQuery } from '../../app/api/domains.api';

type DomainSelectProps = {
  id?: string;
  name?: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLSelectElement>) => void;
  isInvalid?: boolean;
  invalidFeedback?: React.ReactNode;
  disabled?: boolean;
};

const DomainSelect = ({
  id = 'domain',
  name = 'domain',
  value,
  onChange,
  onBlur,
  isInvalid,
  invalidFeedback,
  disabled
}: DomainSelectProps) => {
  const { data, isLoading, isError } = useGetDomainsQuery();
  const domains = data?.domains ?? [];
  const hasCurrentValue = Boolean(value && domains.some(domain => domain.name === value));

  return (
    <>
      <Form.Select
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        isInvalid={isInvalid}
        disabled={disabled || isLoading || isError}
      >
        <option value="">{isLoading ? 'Loading domains...' : 'Select Domain'}</option>
        {!hasCurrentValue && value ? <option value={value}>{value}</option> : null}
        {domains.map(domain => (
          <option key={domain.name} value={domain.name}>
            {domain.displayName}
          </option>
        ))}
      </Form.Select>
      {isInvalid && invalidFeedback ? (
        <Form.Control.Feedback type="invalid">{invalidFeedback}</Form.Control.Feedback>
      ) : null}
      {isError && <small className="text-danger">Failed to load domains. Please refresh and try again.</small>}
    </>
  );
};

export default DomainSelect;
